import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/app/global-error.tsx");
